export default "__VITE_PUBLIC_ASSET__f0284938__"